import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    position: relative;
`;

const NoteText = styled.div`
    font-size: 60px;
    font-weight: 700;
    width: 50px;
    height: 100%;
    position: relative;
    margin: 0 auto;
`;

const AsideText = styled.div`
    font-size: 20px;
    font-weight: 400;
    color: #999;
    position: absolute;
    bottom: calc(50% - 20px);
    left: ${({align}) => {
        if(!align || align === 'left'){
            return "0"
        }else{
            return "auto"
        }
    }};
    right: ${({align}) => {
    if(!align || align === 'right'){
        return "0"
    }else{
        return "auto"
    }
}}
`;

const Direction = styled.sup`
    position: relative;
    top: 0;
    right: 0;
    font-size: 36px;
`;

const Octave = styled.sub`
    position: absolute;
    bottom: -10px;
    right: -20px;
    font-size: 30px;
    color: #757575;
`;

export default ({ children, direction = "natural", octave, cents }) => (
    <Wrapper>
        <NoteText>
            {children}
            {direction === "#" && <Direction>&#x266F;</Direction>}
            {direction === "b" && <Direction>&#x266D;</Direction>}
            {direction === "x" && <Direction>&#x266E;</Direction>}
            <Octave>{octave}</Octave>
        </NoteText>
        <AsideText align={"right"}>
            Cents: {Math.round(cents * 100) / 100 }
        </AsideText>
    </Wrapper>
);
